SP.Accordion = Garnish.Base.extend({
    $el: null,
    $blockHeader: null,
    $blockContent: null,
    $triggerBtn: null,

    init(el) {
        this.$el = $(el)
        this.$blockHeader = this.$el.find('.block-header')
        this.$blockContent = this.$el.find('.block-content')
        this.$triggerBtn = this.$blockHeader.find('.content-trigger').parent()

        this.addListener(this.$triggerBtn, 'click', this.expand)
    },

    expand() {

        if (this.$blockHeader.hasClass('active')) {
            this.collapse()
        } else {
            this.$blockHeader.addClass('active')

            this.$blockContent.velocity('slideDown', {
                duration: 150,
            })
        }
    },

    collapse() {
        this.$blockHeader.removeClass('active')

        this.$blockContent.velocity('slideUp', {
            duration: 150,
        })
    },
})